import { render, staticRenderFns } from "./PEMName.vue?vue&type=template&id=97c2d4ee&scoped=true&"
import script from "./PEMName.vue?vue&type=script&lang=js&"
export * from "./PEMName.vue?vue&type=script&lang=js&"
import style0 from "./PEMName.vue?vue&type=style&index=0&id=97c2d4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c2d4ee",
  null
  
)

export default component.exports